/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PrerequisiteType {
    EVENT = 'EVENT',
    QUESTCOMPLETION = 'QUEST_COMPLETION',
    QUESTMEMBERSHIP = 'QUEST_MEMBERSHIP',
    TOKENBALANCE = 'TOKEN_BALANCE',
    LEVEL = 'LEVEL',
    NFT = 'NFT',
    GUILDMEMBERSHIP = 'GUILD_MEMBERSHIP',
    REFERRAL = 'REFERRAL',
    MENUORDER = 'MENU_ORDER',
    REDEEMLOOTBOX = 'REDEEM_LOOTBOX',
    CHALLENGEMEMBERSHIP = 'CHALLENGE_MEMBERSHIP'
}

export function PrerequisiteTypeFromJSON(json: any): PrerequisiteType {
    return PrerequisiteTypeFromJSONTyped(json, false);
}

export function PrerequisiteTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrerequisiteType {
    return json as PrerequisiteType;
}

export function PrerequisiteTypeToJSON(value?: PrerequisiteType | null): any {
    return value as any;
}

